import React from 'react';
import './Jevseriesize.css';
import jevImage from '../../../imgs/JEVseriesize.webp';  

const Jevseriesize = () => {
  return (
    <div className="jev-container">
   
              <div className="jev-img">
          <img src={jevImage} alt="JEV Series Machine" />
        </div>
     
    </div>
  );
};

export default Jevseriesize;
